"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FONT_SIZE = 16;
var isPx = function (v) { return /px$/.test(v); };
var isPt = function (v) { return /pt$/.test(v); };
var isEm = function (v) { return /[^r]em$/.test(v); };
var isNum = function (v) { return /^[\d|\.]+$/.test(v); };
var hasVal = function (v) { return v !== undefined && v !== ''; };
var ptToPx = function (v) { return Math.round((v * 3) / 4); };
var emToPx = function (v, fontSize) { return Math.round(v * fontSize); };
var pxToEm = function (v, fontSize) { return Math.round(v / fontSize); };
var ptToEm = function (v, fontSize) { return Math.round(ptToPx(v) / fontSize); };
var getFixedVal = function (val) { return +val.toFixed(2).replace(/\.?0+$/, ''); };
var getNum = function (val, fontSize) {
    if (isNum(val))
        return getFixedVal(parseFloat(val));
    if (isEm(val))
        return getFixedVal(parseFloat(val));
    if (isPx(val))
        return getFixedVal(parseFloat(val) / fontSize);
    if (isPt(val))
        return getFixedVal(ptToPx(parseFloat(val)) / fontSize);
    return 0;
};
exports.getNum = getNum;
var getEm = function (val, fontSize) {
    if (isEm(val))
        return parseFloat(val);
    if (isPx(val))
        return pxToEm(parseFloat(val), fontSize);
    if (isPt(val))
        return ptToEm(parseFloat(val), fontSize);
    return 0;
};
exports.getEm = getEm;
var getPx = function (val, fontSize) {
    if (isPx(val))
        return parseFloat(val);
    if (isEm(val))
        return emToPx(parseFloat(val), fontSize);
    if (isPt(val))
        return ptToPx(parseFloat(val));
    return 0;
};
exports.getPx = getPx;
var setSpace = function (res, name, value, fontSize) {
    name.forEach(function (_name) {
        res[_name] = Math.max(getPx(value, fontSize), res[_name] === undefined ? 0 : +res[_name]);
    });
};
var parseSpace = function (res, name, value, fontSize) {
    var parseName = name.replace(/(\w)+-/, '');
    if (parseName === 'margin' || parseName === 'padding') {
        var values = value.split(/\s+/);
        if (values.length === 1) {
            setSpace(res, ['top', 'bottom', 'left', 'right'], values[0], fontSize);
        }
        else if (values.length === 2) {
            setSpace(res, ['top', 'bottom'], values[0], fontSize);
            setSpace(res, ['left', 'right'], values[1], fontSize);
        }
        else if (values.length === 3) {
            setSpace(res, ['top'], values[0], fontSize);
            setSpace(res, ['left', 'right'], values[1], fontSize);
            setSpace(res, ['bottom'], values[2], fontSize);
        }
        else if (values.length === 4) {
            setSpace(res, ['top'], values[0], fontSize);
            setSpace(res, ['right'], values[1], fontSize);
            setSpace(res, ['bottom'], values[2], fontSize);
            setSpace(res, ['left'], values[3], fontSize);
        }
    }
    else {
        setSpace(res, [parseName], value, fontSize);
    }
};
var readTypesetStyle = function (res, name, value, fontSize) {
    if (name === 'text-indent') {
        res.lineIndent = getEm(value, fontSize);
    }
    else if (name === 'line-height') {
        res.lineHeight = getNum(value, fontSize);
    }
    else if (name === 'text-align') {
        res.align = value;
    }
    else if (/^margin|padding/.test(name)) {
        parseSpace(res, name, value, fontSize);
    }
};
exports.readTypesetStyle = readTypesetStyle;
var getValue = function (res) { return (res === undefined || res === '' ? undefined : +res); };
var readTypesetParseResult = function (res) {
    var result = {
        lineHeight: getValue(res.lineHeight),
        lineIndent: getValue(res.lineIndent),
        align: res.align
    };
    result.spaceBefore = getValue(res.top);
    result.spaceAfter = getValue(res.bottom);
    var spaceBoth = res.left || res.right;
    result.spaceBoth = getValue(spaceBoth);
    return result;
};
var parseTypesetStyle = function (style, readStyle, fontSize) {
    if (readStyle === void 0) { readStyle = readTypesetStyle; }
    if (fontSize === void 0) { fontSize = FONT_SIZE; }
    var res = {};
    var styleExecReg = /\s*([\w-]+)\s*:\s*([^;]+)/g;
    var match = styleExecReg.exec(style);
    while (match) {
        readStyle(res, match[1], match[2].trim(), fontSize);
        match = styleExecReg.exec(style);
    }
    return readTypesetParseResult(res);
};
exports.parseTypesetStyle = parseTypesetStyle;
var checkIfRender = function (name, value, attrs) {
    if (!hasVal(value))
        return false;
    if (attrs[name]) {
        var defaultValue = attrs[name].default;
        if (typeof defaultValue === 'string' && defaultValue === value.toString())
            return false;
        if (typeof defaultValue === 'number' && defaultValue === parseInt(value, 10))
            return false;
        if (defaultValue === value)
            return false;
    }
    return true;
};
// toDOM
var getMarginStyle = function (spaceBefore, spaceAfter, spaceBoth, dAttrs) {
    if (spaceBefore === void 0) { spaceBefore = ''; }
    if (spaceAfter === void 0) { spaceAfter = ''; }
    if (spaceBoth === void 0) { spaceBoth = ''; }
    var hasBefore = checkIfRender('spaceBefore', spaceBefore, dAttrs);
    var hasAfter = checkIfRender('spaceAfter', spaceAfter, dAttrs);
    var hasBoth = checkIfRender('spaceBoth', spaceBoth, dAttrs);
    if (hasBefore && hasAfter && hasBoth) {
        return "margin: " + (spaceBefore || 0) + "px " + (spaceBoth || 0) + "px " + (spaceAfter || 0) + "px;";
    }
    var style = '';
    if (hasBefore)
        style += "margin-top: " + spaceBefore + "px;";
    if (hasAfter)
        style += "margin-bottom: " + spaceAfter + "px;";
    if (hasBoth)
        style += "margin-left: " + spaceBoth + "px; margin-right: " + spaceBoth + "px;";
    return style;
};
exports.getMarginStyle = getMarginStyle;
var getTypesetDOMStyle = function (attrs, dAttrs) {
    if (dAttrs === void 0) { dAttrs = {}; }
    var style = '';
    var align = attrs.align, spaceAfter = attrs.spaceAfter, spaceBefore = attrs.spaceBefore, spaceBoth = attrs.spaceBoth, lineHeight = attrs.lineHeight, lineIndent = attrs.lineIndent;
    if (align !== (dAttrs.align && dAttrs.align.default))
        style += "text-align: " + align + ";";
    if (lineHeight && lineHeight !== (dAttrs.lineHeight && dAttrs.lineHeight.default)) {
        style += "line-height: " + lineHeight + ";";
    }
    if (lineIndent && lineIndent !== (dAttrs.lineIndent && dAttrs.lineIndent.default)) {
        style += "text-indent: " + lineIndent + "em;";
    }
    if (hasVal(spaceAfter) || hasVal(spaceBefore) || hasVal(spaceBoth)) {
        style += getMarginStyle(spaceBefore, spaceAfter, spaceBoth, dAttrs);
    }
    return style;
};
exports.getTypesetDOMStyle = getTypesetDOMStyle;
//# sourceMappingURL=parse.js.map